//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    class="wait_for_mobile"
    width="150px"
    height="150px"
    viewBox="0 0 300 300"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>wait_for_mobile</title>
    <defs></defs>
    <g
      id="Page-5"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="wait_for_mobile">
        <g id="Group-704" transform="translate(84.000000, 33.000000)">
          <path
            d="M112.861046,234 L19.1389537,234 C8.56929031,234 0,225.425616 0,214.84623 L0,19.1522303 C0,8.57438435 8.56929031,0 19.1389537,0 L112.861046,0 C123.43071,0 132,8.57438435 132,19.1522303 L132,214.84623 C132,225.425616 123.43071,234 112.861046,234 Z"
            id="Stroke-355"
            :style="{ stroke: store.state.Style.themeColor }"
            stroke-width="2"
          ></path>
          <path
            d="M0.145506977,29.1944 L131.812437,29.1944"
            id="Fill-361"
          ></path>
          <path
            d="M0,29 L131.66693,29"
            id="Stroke-363"
            stroke-width="2"
            :style="{ stroke: store.state.Style.themeColor }"
          ></path>
          <path
            d="M0,198 L131.66693,198"
            id="Stroke-363-Copy"
            stroke-width="2"
            :style="{ stroke: store.state.Style.themeColor }"
          ></path>
          <path
            d="M74,216 C74,220.418869 70.4176534,224 66.0007829,224 C61.5823466,224 58,220.418869 58,216 C58,211.582697 61.5823466,208 66.0007829,208 C70.4176534,208 74,211.582697 74,216 Z"
            id="Stroke-367"
            stroke-width="2"
            :style="{ stroke: store.state.Style.themeColor }"
          ></path>
          <path
            d="M19,13 C19,15.209002 17.2086514,17 14.9992171,17 C12.7913486,17 11,15.209002 11,13 C11,10.790998 12.7913486,9 14.9992171,9 C17.2086514,9 19,10.790998 19,13 Z"
            id="Stroke-371"
            stroke-width="2"
            :style="{ stroke: store.state.Style.themeColor }"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
